import React from "react";
import LoginContainer from "../containers/LoginContainer";

export default function Login() {
  return <LoginContainer />;
}
